
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import React, { useState, useEffect } from 'react';
import Button from "beaktShared/components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from 'react-i18next';

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

const GerenciaModal = () => { 

  const classes = useStyles();
  const [DetailModal, setDetailModal] = useState([]);
  const [confModal, setConfModal] = useState({
    showmodal: false,
    dataShow: (<div></div>)
  });

  useEffect(() => {
      
    if(confModal.showmodal)
    {
      showDetailModal(confModal.dataShow);
    }
    else if(!confModal.showmodal)
    {
      hideDetailModal();    
    }
  // eslint-disable-next-line  
  }, [confModal]);

  const showDetailModal = (dataShow) => {
    setDetailModal(
        <Dialog
            classes={{
                root: classes.center + " " + classes.modalRoot,
                paper: classes.modal + ' ' + classes.modalMedium
            }}
            open={true}
            keepMounted
            onClose={() => hideDetailModal()}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
        >
            <DialogTitle  disableTypography  className={classes.modalHeader} style={{background:'#dddddd',paddingBottom:'10px'}} >
                <Button
                    justIcon
                    className={classes.modalCloseButton}
                    key="close"
                    aria-label="Close"
                    color="transparent"
                    onClick={() => hideDetailModal()}
                >
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle} style={{color:'#707070'}}>
                <Trans i18nKey="label.detail">
                  Detalhe
                </Trans>
                </h4>
            </DialogTitle>
            <DialogContent
                id="classic-modal-slide-description"
                className={classes.modalBody} style={{paddingTop:'20px'}}
            >
                {dataShow}

            </DialogContent>
            <DialogActions className={classes.modalFooter}>
                <Button
                    onClick={() => hideDetailModal()}
                >
                <Trans i18nKey="button.close">
                  Fechar
                </Trans>
                    </Button>
            </DialogActions>
        </Dialog>
    );
  };
  const hideDetailModal = () => {
    setDetailModal(null);
  };

  return [DetailModal, setConfModal];
};

export {GerenciaModal};